export default {
    breakpoints: ["20em", "30em", "37.5em", "53.4em", "64em", "80em"],
    colors: {
        text: "#1C1C1C",
        background: "#fcfde8",
        primary: "#73c7d0",
        secondary: "#92e3e9",
        accent: "#101010",
        muted: "#f6f6f6",
        modes: {
            helvetia: {
                text: "#1C1C1C",
                background: "#f0f7f7",
                primary: "#5B674E",
                secondary: "#F0E7CE",
                accent: "#8F6648",
                muted: "#f6f6f6",
            },
            genre: {
                text: "#1C1C1C",
                background: "#ddcaed",
                primary: "#af82d5",
                secondary: "#5b197b",
                accent: "#af82d5",
                muted: "#f6f6f6",
            },
            science: {
                text: "#1C1C1C",
                background: "#AACBEE",
                primary: "#3397a0",
                secondary: "#92e3e9",
                accent: "#73c7d0",
                muted: "#f6f6f6",
            },
            trashquiz: {
                text: "#0C2D48",
                background: "#B1D4E0",
                primary: "#2E8BC0",
                secondary: "#92e3e9",
                accent: "#2E8BC0",
                muted: "#f6f6f6",
            },
        },
    },
    fonts: {
        body: "Montserrat, sans-serif",
        heading: "Alegreya Sans SC, sans-serif",
        monospace: "Roboto Mono, monospace",
    },
    fontWeights: {
        body: 200,
        heading: 200,
        bold: 300,
    },
    shadows: {
        small: "0 0 4px rgba(0, 0, 0, .125)",
        large: "0 0 24px rgba(0, 0, 0, .125)",
    },
    styles: {
        root: {
            fontFamily: "body",
            fontWeight: "body",
            fontSize: [12, 14, 16, 18, 20, 22],
        },
    },
}
